/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getStorefrontCheckoutGuest} from '../api'

 export const useQueryGetStorefrontCheckoutGuest = createReactQueryHook('getStorefrontCheckoutGuest', getStorefrontCheckoutGuest)
